import {
  checkMessageEn,
  checkMessageUrl,
  validateSpace,
  validateSpaceTextInput,
} from '@Utils/validation';
import { IGreenhouseStrategyFormValues } from '../EsgGreenhouseFormProvider/types';

export const checkGhStrategyCompletionTh = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
) => {
  if (!greenhouseStrategy) return false;

  const { plan } = greenhouseStrategy;

  if (plan?.descriptionTh && validateSpace(plan.descriptionTh)) return true;

  return false;
};

export const checkGhStrategyCompletionEn = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
): boolean => {
  if (!greenhouseStrategy) return false;

  const { plan } = greenhouseStrategy;

  if (
    plan &&
    plan.descriptionEn &&
    validateSpace(plan.descriptionEn) &&
    checkMessageEn(plan.descriptionEn)
  ) {
    return true;
  }
  return false;
};

export const checkGhStrategyIntroductionValidTh = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
): boolean => {
  const { introduction } = greenhouseStrategy || {};
  const isIntroSpaceThValid = validateSpace(introduction?.descriptionTh);

  return isIntroSpaceThValid;
};

export const checkGhStrategyIntroductionValidEn = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
): boolean => {
  const { introduction } = greenhouseStrategy || {};

  const isIntroSpaceEnValid = validateSpace(introduction?.descriptionEn);
  const isIntroEnValid =
    !introduction?.descriptionEn || checkMessageEn(introduction?.descriptionEn);

  return isIntroSpaceEnValid && isIntroEnValid;
};

export const checkGhStrategyRemarkValidTh = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
): boolean => {
  const { remark } = greenhouseStrategy || {};
  const isRemarkSpaceThValid = validateSpaceTextInput(remark?.descriptionTh);

  return isRemarkSpaceThValid;
};

export const checkGhStrategyRemarkValidEn = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
): boolean => {
  const { remark } = greenhouseStrategy || {};

  const isRemarkSpaceEnValid = validateSpaceTextInput(remark?.descriptionEn);
  const isRemarkEnValid =
    !remark?.descriptionEn || checkMessageEn(remark?.descriptionEn);

  return isRemarkSpaceEnValid && isRemarkEnValid;
};

export const checkGhStrategyPlanRemarkValidTh = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
): boolean => {
  const { plan } = greenhouseStrategy || {};
  const isRemarkSpaceThValid = validateSpaceTextInput(
    plan?.remark?.descriptionTh
  );

  return isRemarkSpaceThValid;
};

export const checkGhStrategyPlanRemarkValidEn = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues
): boolean => {
  const { plan } = greenhouseStrategy || {};

  const isRemarkSpaceEnValid = validateSpaceTextInput(
    plan?.remark?.descriptionEn
  );
  const isRemarkEnValid =
    !plan?.remark?.descriptionEn || checkMessageEn(plan?.remark?.descriptionEn);

  return isRemarkSpaceEnValid && isRemarkEnValid;
};

export const checkGhStrategyUrlValid = (
  greenhouseStrategy?: IGreenhouseStrategyFormValues,
  language?: 'Th' | 'En'
): boolean => {
  if (!greenhouseStrategy) return false;

  const url =
    language === 'Th'
      ? greenhouseStrategy.plan?.urlTh
      : greenhouseStrategy.plan?.urlEn;
  return !url || checkMessageUrl(url);
};
